module.exports = __webpack_public_path__ + "static/img/scene2.38db8896.jpg";